import { calcTotals } from './totals.js';

function normalizeString(value) {
  if (typeof value !== 'string') {
    return '';
  }
  return value.trim();
}

export function validateGuia(guia, context = {}) {
  const errors = [];
  const {
    cliente = null,
    remitos = Array.isArray(guia?.remitos) ? guia.remitos : [],
  } = context;

  if (!normalizeString(guia?.sucursalId)) {
    errors.push('Seleccioná una sucursal.');
  }

  if (!normalizeString(guia?.puntoVentaId)) {
    errors.push('Seleccioná un punto de venta.');
  }

  if (!guia?.fecha) {
    errors.push('Indicá la fecha de emisión.');
  }

  if (!normalizeString(guia?.clienteId)) {
    errors.push('Seleccioná un cliente.');
  }

  if (!normalizeString(guia?.remitente)) {
    errors.push('El remitente es obligatorio.');
  }

  if (!normalizeString(guia?.destinatario)) {
    errors.push('El destinatario es obligatorio.');
  }

  if (remitos.length === 0) {
    errors.push('Agregá al menos un remito.');
  }

  const seenRemitos = new Set();
  remitos.forEach(remito => {
    const numero = normalizeString(remito.numero);
    if (!numero) {
      errors.push('Cada remito debe tener número.');
      return;
    }
    if (seenRemitos.has(numero)) {
      errors.push(`Remito duplicado: ${numero}.`);
    }
    seenRemitos.add(numero);
  });

  const totals = calcTotals(remitos);

  if (totals.bultos < 1) {
    errors.push('La suma de bultos debe ser al menos 1.');
  }

  if (totals.kgReales < 0 || totals.m3 < 0) {
    errors.push('Los totales de kg reales y m³ no pueden ser negativos.');
  }

  if (typeof guia?.bultos === 'number' && guia.bultos !== totals.bultos) {
    errors.push('Los bultos totales no coinciden con la suma de remitos.');
  }

  if (typeof guia?.kgReales === 'number' && Number(guia.kgReales) !== totals.kgReales) {
    errors.push('Los kg reales totales no coinciden con la suma de remitos.');
  }

  if (typeof guia?.m3 === 'number' && Number(guia.m3) !== totals.m3) {
    errors.push('Los m³ totales no coinciden con la suma de remitos.');
  }

  if (typeof guia?.aforo === 'number' && guia.aforo !== totals.aforo) {
    errors.push('El aforo total no coincide con la suma de remitos.');
  }

  const valorDeclarado = Number.parseFloat(guia?.valorDeclarado ?? 0) || 0;
  if (valorDeclarado < 0) {
    errors.push('El valor declarado no puede ser negativo.');
  }

  if (valorDeclarado > 0) {
    if (cliente?.seguroPropio) {
      const polizaVigente = normalizeString(cliente?.poliza || guia?.poliza);
      if (!polizaVigente) {
        errors.push('El cliente tiene seguro propio, indicá la póliza vigente.');
      }
    } else if (!guia?.seguroEmpresa) {
      errors.push('Confirmá si se utilizará el seguro de la empresa.');
    }
  }

  const contrareembolso = Number.parseFloat(guia?.contrareembolso ?? 0) || 0;
  if (contrareembolso < 0) {
    errors.push('El contrareembolso no puede ser negativo.');
  }
  if (contrareembolso > 0 && !normalizeString(guia?.modoContrareembolso)) {
    errors.push('Indicá el modo de devolución del contrareembolso.');
  }

  return {
    isValid: errors.length === 0,
    errors,
    totals,
  };
}

export function formatNumeroGuia(pvCodigo, numero) {
  if (!pvCodigo && !numero) {
    return '';
  }
  const normalizedPv = String(pvCodigo ?? '').trim();
  const normalizedNumero = Number.parseInt(numero ?? 0, 10);
  const paddedPv = /^\d+$/.test(normalizedPv) ? normalizedPv.padStart(4, '0') : normalizedPv;
  const paddedNumero = Number.isNaN(normalizedNumero)
    ? ''
    : normalizedNumero.toString().padStart(12, '0');
  if (!paddedPv) {
    return paddedNumero;
  }
  if (!paddedNumero) {
    return normalizedPv;
  }
  return `${paddedPv}-${paddedNumero}`;
}
